import { Rule } from "@/components/DataCleaning/models/Rule";
import { SchemaCoalesceService } from "./SchemaCoalesceService";
import { IQueueExecutionDataCleaningProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import { DataCleaningJsonParsingInputType } from "@/components/DataCleaning/services/DataCleaningJsonParsingService";
import { CdnSchemaJsonParsingResult } from "../models/CdnSchemaJsonParsingResult";


export class DataCleaningSchemaCoalesceService extends SchemaCoalesceService<Rule, DataCleaningJsonParsingInputType, IQueueExecutionDataCleaningProp> {

    public coalesceParsingResultparsingResult(parsingResult: CdnSchemaJsonParsingResult<Rule, DataCleaningJsonParsingInputType>): IQueueExecutionDataCleaningProp {
        if (parsingResult == null) throw Error("parsingResult is required");
        if (!parsingResult.valid) throw Error("valid parsingResult required");

        const coalesceResult: IQueueExecutionDataCleaningProp = {
            rules: parsingResult.parsedEntities ?? [],
            output: {
                fileName: parsingResult.parsedValue?.dataCleaning?.output?.fileName
                    ?? parsingResult.parsedValue?.output?.fileName
                    ?? ""
            }
        };

        return coalesceResult;

    }

}